import React, { Dispatch } from 'react'
import DropdownSelect from '../../Helpers/DropdownSelect'
import {
  BASE_ELECTION_KEY,
  BYELECTIONS_KEY,
  ELECTION_2019_KEY
} from '../../../controllers/DataController'

import { connect } from 'react-redux'

import './ComparisonSelect.scss'
import {
  IReduxAction,
  IResultKeysProps,
  PollsToShow,
  mapResultKeysToProps
} from '../../../utils/ReduxStore'
import PollsTab from '../../Polls/PollsTab'

import U from '../../../utils/Utilities'

interface IDispatchProps {
  setBaseResultKey: (baseResultKey: string) => void
  setCompareResultKey: (compareResultKey: string) => void
  reproject: () => void
}

interface IProps extends IResultKeysProps, IDispatchProps {}

interface IState {
  base: string
  comparison: string
  hideDetails: boolean
}

class ComparisonSelect extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)

    this.state = {
      base: BYELECTIONS_KEY,
      comparison: ELECTION_2019_KEY,
      hideDetails: false
    }
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState): void {
    if (
      prevState.base !== this.state.base ||
      prevState.comparison !== this.state.comparison
    ) {
      this.emitEvent()
    }
    if (prevProps.lastReset !== this.props.lastReset) {
      this.setState({
        base: BYELECTIONS_KEY,
        comparison: ELECTION_2019_KEY,
        hideDetails: false
      })
    }
  }

  protected emitEvent(): void {
    const event = document.createEvent('Event')
    event.initEvent(`resize-map`, true, true)
    window.dispatchEvent(event)
  }

  public render(): JSX.Element {
    const { base, comparison, hideDetails } = this.state
    const hasDetails =
      comparison === 'nationalSlider' || comparison === 'regionalSliders'

    const baseItems = [
      {
        id: BASE_ELECTION_KEY,
        icon: 'fas fa-box-ballot',
        children: '2015 results'
      },
      {
        id: BYELECTIONS_KEY,
        icon: 'fas fa-box-ballot',
        children: '2015 + by-elections'
      }
    ]

    if (comparison !== BYELECTIONS_KEY) {
      baseItems.push({
        id: ELECTION_2019_KEY,
        icon: 'fas fa-box-ballot',
        children: '2019 (prelim)'
      })
    }

    if (comparison !== BYELECTIONS_KEY && comparison !== ELECTION_2019_KEY) {
    }

    return (
      <div id="Comparison" className="ComparisonSelect row d-flex py-1">
        <div className="col-9">
          <div className="d-flex align-items-center">
            <h2 className="d-none d-sm-inline-block mr-1 mr-sm-2">Compare</h2>
            <DropdownSelect
              id="ComparisonTypeSelect"
              selectedItemId={base}
              onChange={(id: string): void => {
                this.setState({ base: id })
                this.props.setBaseResultKey(id)
                this.props.reproject()
              }}
              items={baseItems}
            />
            <span className="To mx-1 mx-md-2 d-sm-none">vs</span>
            <span className="To mx-2 d-none d-sm-none d-sm-inline-block">
              to
            </span>
            <DropdownSelect
              id="ComparisonTypeSelect"
              selectedItemId={comparison}
              onChange={(id: string): void => {
                console.log('id', id)
                this.setState(
                  { comparison: id, hideDetails: false },
                  this.emitEvent
                )
                if (id === BYELECTIONS_KEY || id === ELECTION_2019_KEY) {
                  this.props.setCompareResultKey(id)
                  this.props.reproject()
                } else {
                  this.props.setCompareResultKey('polls')
                }
              }}
              items={[
                {
                  id: 'nationalSlider',
                  icon: 'fas fa-poll-people',
                  children: 'National poll slider'
                },
                {
                  id: 'regionalSliders',
                  icon: 'fas fa-poll-people',
                  children: 'Regional poll sliders'
                },
                {
                  id: BYELECTIONS_KEY,
                  icon: 'fas fa-box-ballot',
                  children: '2015 + by-elections'
                },
                {
                  id: ELECTION_2019_KEY,
                  icon: 'fas fa-box-ballot',
                  children: '2019 (prelim)'
                }
              ]}
            />
          </div>
        </div>
        <div className="col-3 text-right">
          {hasDetails && (
            <button
              className="btn btn-secondary"
              onClick={(): void =>
                this.setState(
                  { hideDetails: !this.state.hideDetails },
                  this.emitEvent
                )
              }
            >
              <span className={U.classIf(hideDetails, '', 'Hidden')}>
                <i className={`fas fa-plus`} />
              </span>
              <span className={U.classIf(hideDetails, 'Hidden', '')}>
                <i className={`fas fa-minus`} />
              </span>
              <span className="d-none d-sm-inline ml-1 ml-sm-2">
                {hideDetails ? 'Show' : 'Hide'}
              </span>
            </button>
          )}
        </div>
        {!hideDetails && hasDetails && (
          <PollsTab pollsToShow={comparison as PollsToShow} />
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  setBaseResultKey: (baseResultKey: string): void => {
    dispatch({ type: 'SET_BASE_RESULT_KEY', baseResultKey })
  },
  setCompareResultKey: (compareResultKey: string): void => {
    dispatch({
      type: 'SET_COMPARE_RESULT_KEY',
      compareResultKey
    })
  },
  reproject: (): void => dispatch({ type: 'REPROJECT' })
})

export default connect(
  mapResultKeysToProps,
  mapDispatchToProps
)(ComparisonSelect)
